import React from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import SupportNav from "../../../parts/support-nav";

function View(props) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="Main">
      <SupportNav />

      <div className="Content">{t("support.landingPage")}</div>
    </div>
  );
}

const Support = (app) => {
  app.get("/", set("heading", "Support"), ({ res }) => (res.body = <View />));
};

export default Support;
